import { render, staticRenderFns } from "./order-view-tabs-tasks.vue?vue&type=template&id=adada46c&"
import script from "./order-view-tabs-tasks.ts?vue&type=script&lang=ts&"
export * from "./order-view-tabs-tasks.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports